module.exports = __webpack_public_path__ + "img/education.ba7b3d6e.svg";